import axios from 'axios';
import { ApiResponse } from '../../../shared/types';

const API_BASE = '/api/v1/chamdiem';

export interface ChamDiemPayload {
  MaHS: string;
  PhieuID: number;
  NguoiCham: string;
  chiTiet: { TieuChiID: number; DiemThucTe: number }[];
}

class ChamDiemService {
  async saveGrade(data: ChamDiemPayload): Promise<ApiResponse> {
    const response = await axios.post<ApiResponse>(API_BASE, data);
    return response.data;
  }
}

export default new ChamDiemService();
 